import { render, staticRenderFns } from "./RLVHistory.vue?vue&type=template&id=b036edde&scoped=true"
import script from "./RLVHistory.vue?vue&type=script&lang=js"
export * from "./RLVHistory.vue?vue&type=script&lang=js"
import style0 from "./RLVHistory.vue?vue&type=style&index=0&id=b036edde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b036edde",
  null
  
)

export default component.exports